// src/pages/OAuthSuccess.js - FIXED ESLint Warning

import React, { useEffect, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { API_URL } from '../utils/config';

const OAuthSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser, setToken } = useAuth();

  // Wrap fetchUserData in useCallback to fix ESLint warning
  const fetchUserData = useCallback(async (token) => {
    try {
      const response = await axios.get(`${API_URL}/api/auth/me`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.data) {
        setUser(response.data);
        setToken(token);
        
        console.log('✅ OAuth Success - User logged in:', response.data);
        
        setTimeout(() => {
          window.location.href = '/';
        }, 100);
      } else {
        console.error('❌ No user data received');
        navigate('/login');
      }
    } catch (error) {
      console.error('❌ Error fetching user data:', error);
      localStorage.removeItem('token');
      navigate('/login');
    }
  }, [setUser, setToken, navigate]);

  useEffect(() => {
    const token = searchParams.get('token');

    if (token) {
      localStorage.setItem('token', token);
      fetchUserData(token);
    } else {
      navigate('/login');
    }
  }, [searchParams, navigate, fetchUserData]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      flexDirection: 'column',
      gap: '20px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <div style={{
        width: '60px',
        height: '60px',
        border: '6px solid #f3f3f3',
        borderTop: '6px solid #fff',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      <h2 style={{ color: '#fff', fontSize: '1.5rem' }}>Signing you in...</h2>
      <p style={{ color: '#fff', opacity: 0.8 }}>Please wait</p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default OAuthSuccess;